// src/data/monthlyExamPlan.js
// ==========================================================================
// خطة امتحانات الشهر الثابتة (سلسلة الأزهري)
// ==========================================================================
// ده ملف جديد بالكامل (مش بيعدل ولا حرف في أي ملف تاني) بيوصف قائمة الامتحانات
// الشهرية الثابتة اللي المدرس هيختار منها بدل ما يكتب اسم الامتحان يدوي.
//
// القاعدة:
// - كل امتحان "أونلاين" (بيحله الطالب على المنصة وتتصحح نتيجته أوتوماتيك) درجته
//   ثابتة = 12.5
// - كل مادة ليها درجة "ورقي" ثابتة بيدخلها المدرس بإيده = 25، ماعدا الفقه = 50
// - في الآخر: درجة المادة الكاملة = مجموع كل امتحاناتها الأونلاين + الورقي
//   (حديث = 12.5+12.5+25 = 50) (فقه = 12.5*4 + 50 = 100)
//
// ملحوظة: القائمة دي مبنية فوق الموديلات الموجودة أصلاً (Exam / Grade) من غير
// أي تعديل في الـ backend أو في الـ database:
//   - كل عنصر "أونلاين" هيتحفظ كـ Exam عادي (زي أي امتحان بتعمله دلوقتي)
//   - كل عنصر "ورقي" هيتحفظ كـ Exam برضو بس من غير أسئلة (questions: [])،
//     غرضه إنه بس "وعاء" تحط فيه درجة الورقي من صفحة "الدرجات" الموجودة
//     أصلاً (بنفس الطريقة اللي بتشتغل بيها دلوقتي بالظبط)

// درجة كل امتحان أونلاين بقت متبادلة: الأول 12 والتاني 13 (وهكذا لو أكتر من 2)
// عشان مجموعهم يفضل زي الأول (12+13=25 للمواد التنائية، 12+13+12+13=50 للفقه)
export const ODD_SLOT_SCORE = 12;
export const EVEN_SLOT_SCORE = 13;
const scoreForSlot = (slot) => (slot % 2 === 1 ? ODD_SLOT_SCORE : EVEN_SLOT_SCORE);

// المواد الخمسة "الأساسية" + الفقه، بالترتيب اللي طلبته بالظبط
export const MONTHLY_SUBJECTS = [
  { key: 'hadith', label: 'حديث', onlineCount: 2, paperScore: 25 },
  { key: 'tafsir', label: 'تفسير', onlineCount: 2, paperScore: 25 },
  { key: 'seera', label: 'سيرة', onlineCount: 2, paperScore: 25 },
  { key: 'tawheed', label: 'توحيد', onlineCount: 2, paperScore: 25 },
  { key: 'fiqh', label: 'فقه', onlineCount: 4, paperScore: 50 },
];

// بتحول القائمة اللي فوق لقائمة "عناصر" مسطحة (أونلاين + ورقي) جاهزة للعرض
// في أي Select. كل عنصر فيه كل البيانات اللازمة لإنشاء الامتحان أوتوماتيك.
export const buildMonthlyExamItems = () => {
  const items = [];
  MONTHLY_SUBJECTS.forEach((subject) => {
    for (let slot = 1; slot <= subject.onlineCount; slot += 1) {
      const label =
        subject.onlineCount > 1
          ? `${subject.label} أونلاين ${slot}`
          : `${subject.label} أونلاين`;
      items.push({
        id: `${subject.key}-online-${slot}`,
        subjectKey: subject.key,
        subject: subject.label,
        kind: 'online',
        slot,
        label,
        maxScore: scoreForSlot(slot),
        examType: subject.onlineCount > 1 ? `أونلاين ${slot}` : 'أونلاين',
      });
    }
    items.push({
      id: `${subject.key}-paper`,
      subjectKey: subject.key,
      subject: subject.label,
      kind: 'paper',
      label: `${subject.label} ورقي`,
      maxScore: subject.paperScore,
      examType: 'ورقي',
    });
  });
  return items;
};

export const MONTHLY_EXAM_ITEMS = buildMonthlyExamItems();

// إجمالي درجة كل مادة (كل الأونلاين + الورقي) - يفيد في شاشة التقرير الشهري
export const subjectTotalScore = (subjectKey) => {
  const subject = MONTHLY_SUBJECTS.find((s) => s.key === subjectKey);
  if (!subject) return 0;
  let onlineTotal = 0;
  for (let slot = 1; slot <= subject.onlineCount; slot += 1) {
    onlineTotal += scoreForSlot(slot);
  }
  return onlineTotal + subject.paperScore;
};

export const MONTHLY_TOTAL_SCORE = MONTHLY_SUBJECTS.reduce(
  (sum, s) => sum + subjectTotalScore(s.key),
  0
);
